export default function AboutSection() {
  return (
    <section id="about" className="w-full py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-14">
          <div className="flex-1">
            <span className="text-sm font-semibold text-primary-600 uppercase tracking-wider whitespace-nowrap">
              关于我们
            </span>
            <h2 className="mt-2 text-2xl md:text-4xl font-bold font-heading text-foreground-950">
              51爆料 —— 你的每日热点追踪器
            </h2>
            <div className="mt-6 space-y-4">
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                51爆料成立于对信息透明和热点追踪的执着追求。我们致力于打造一个集每日爆料、话题竞赛、热度排行为一体的综合内容平台，
                让每一位用户都能在第一时间获取全网最新、最热的爆料资讯。
              </p>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                我们的编辑团队全天候监测各大平台和信源，运用智能聚合技术对海量信息进行筛选、核实和归类，
                确保呈现在你面前的每一条内容都经过精心整理。从娱乐圈到科技圈、从社会热点到国际动态，
                51爆料每日大赛专区覆盖 12+ 领域，以最快的更新速度和最全的内容覆盖，成为百万用户每日必刷的爆料聚合入口。
              </p>
              <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                我们相信，好的爆料平台不仅是信息的搬运工，更是观点的催化剂。通过每日大赛排行和话题竞赛机制，
                51爆料让每一条爆料都能引发讨论与思考，让信息消费变得更有参与感和价值感。我们持续优化产品体验，
                致力于成为中文互联网上最值得信赖的每日爆料聚合平台。
              </p>
            </div>
          </div>
          <div className="flex-1 w-full max-w-[480px] lg:max-w-none">
            <div className="w-full aspect-[4/3] rounded-2xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=A%20warm%20and%20modern%20editorial%20office%20scene%20with%20abstract%20news%20monitoring%20screens%2C%20crimson%20and%20amber%20accent%20lighting%2C%20professional%20team%20workspace%20vibe%2C%20geometric%20composition%2C%20clean%20modern%20aesthetic%2C%20atmospheric%20light%2C%20no%20text%20or%20recognizable%20people%20faces&width=960&height=720&seq=about-51bl&orientation=landscape"
                alt="51爆料团队工作场景 - 每日爆料聚合平台"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}